<style scoped>

</style>
<template>
    <div>
        <div class="line">
            <Button type="primary" @click="editCourse(new_course)" icon="md-add">添加课程</Button>
        </div>

        <Table :columns="columns" :data="courses"></Table>

        <Modal title="添加/编辑课程"
               width="500"
               v-model="edit_config.modal"
               :loading="edit_config.loading"
               @on-ok="updateCourse"
               ok-text="确定">
            <Form ref="formInline" :model="edit_course" :label-width="60">
                <FormItem label="课程名称">
                    <i-input type="text" v-model="edit_course.name" placeholder="名称..."></i-input>
                </FormItem>
                <FormItem label="所属团队">
                    <Select v-model="edit_course.team_id" transfer v-if="teams.length">
                        <Option v-for="team in teams" :value="team.id" :key="team.id" v-if="!team.del">{{ team.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="课程简介">
                    <i-input type="textarea" v-model="edit_course.desc" placeholder="课程简介..."></i-input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        data(){
            return {
                edit_course: {},
                new_course: {
                    id: 0,
                    name: '',
                    team_id: 0,
                    desc: ''
                },
                courses: [],
                columns: [
                    {
                        title: '课程名称',
                        key: 'name'
                    },
                    {
                        title: '所属团队',
                        key: 'team_id',
                        render: (h, params)=>{
                            let row = params.row;
                            let team = this.teams_hash[row.team_id];
                            if(team){
                                return h('span', team.name);
                            }else{
                                return h('span', '-');
                            }
                        }
                    },
                    {
                        title: '课程简介',
                        key: 'desc'
                    },
                    {
                        title: '操作',
                        render: (h, params)=>{
                            return h('Button', {
                                props: {
                                    size: 'small'
                                },
                                on: {
                                    click: ()=>{
                                        this.editCourse(params.row);
                                    }
                                }
                            }, '编辑')
                        }
                    }
                ],
                edit_config: {
                    modal: false,
                    loading: true
                }
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            ...mapGetters({
                teams: 'async/root_teams',
                teams_hash: 'async/root_teams_hash',
            }),
        },
        created(){
            this.getCourses();
        },
        mounted(){
            //
        },
        methods: {
            getCourses(){
                Util.ajax.get(Util.api.get_courses).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.courses = res.data.courses;
                    }else{
                        //失败
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            editCourse(course){
                this.edit_course = Util.clone(course);
                this.edit_config.modal = true;
            },
            updateCourse(){
                Util.ajax.post(Util.api.update_course, this.edit_course).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.edit_config.modal = false;
                        Util.insertOrUpdateArrayItem(this.courses, res.data.course);
                    }else{
                        this.resetLoading();
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.resetLoading();
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            resetLoading(){
                this.edit_config.loading = false;
                setTimeout(()=>{
                    this.edit_config.loading = true;
                }, 500);
            }
        }
    }
</script>
